// ------------------------------------------------------------------------------
// SparkleButton
// author: mudas
// created: 2025/7/29
// ------------------------------------------------------------------------------

import React, { FC, PropsWithChildren } from 'react';

import { Button, ButtonProps } from '@fuxi/eevee-ui';

import cx from './index.module.css';

export interface IProps extends ButtonProps {}

const SparkleStar = () => (
  <svg className={cx('sparkle-star')} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      stroke-linejoin="round"
      stroke-linecap="round"
      d="m627.06996,245.51063l42.65932,-146.87982l42.65932,146.87982c11.02432,37.94018 31.69804,72.49135 60.06431,100.39517c28.37125,27.90008 63.50101,48.23411 102.07287,59.07718l149.38663,42.00981l-149.33437,41.95837c-38.57186,10.84307 -73.70162,31.1771 -102.07287,59.07718c-28.36627,27.90506 -49.03999,62.45748 -60.06431,100.39517l-42.71199,146.93125l-42.65932,-146.87982c-11.02432,-37.93811 -31.69804,-72.49011 -60.06431,-100.39517c-28.37125,-27.90008 -63.50101,-48.23411 -102.07287,-59.07718l-149.38663,-42.00981l149.33437,-41.95837c38.57186,-10.84307 73.70162,-31.1771 102.07287,-59.07718c28.36627,-27.90423 49.03999,-62.4554 60.06431,-100.39517l0.05267,-0.05143z"
    />
    <path
      stroke-linejoin="round"
      stroke-linecap="round"
      d="m268.41752,73.45559l-9.65255,37.7211c-5.52805,21.63029 -16.96495,41.38741 -33.08713,57.15371c-16.12217,15.7663 -36.32399,26.95139 -58.44383,32.35632l-38.57267,9.43944l38.57267,9.43944c22.11984,5.40493 42.32166,16.59003 58.44383,32.35632c16.12217,15.7663 27.55907,35.52342 33.08713,57.15371l9.65255,37.7211l9.65255,-37.7211c5.52512,-21.62678 16.95645,-41.38009 33.07159,-57.14639c16.11514,-15.7663 36.30904,-26.95139 58.42214,-32.36365l38.6099,-9.43944l-38.6099,-9.43944c-22.1131,-5.41226 -42.307,-16.59735 -58.42214,-32.36365c-16.11514,-15.7663 -27.54647,-35.5199 -33.07159,-57.14639l-9.65255,-37.7211z"
    />
    <path
      stroke-linejoin="round"
      stroke-linecap="round"
      d="m273.30028,533.35275l-29.9339,84.69716c-8.39177,23.72413 -22.5313,45.28274 -41.2954,62.96558c-18.7641,17.68284 -41.64134,31.00693 -66.81664,38.91497l-89.87809,28.20867l89.87809,28.20867c25.17455,7.90879 48.05254,21.23213 66.81664,38.91497c18.7641,17.68284 32.90288,39.24145 41.2954,62.96558l29.9339,84.69716l29.9339,-84.69716c8.39177,-23.72413 22.5313,-45.28274 41.2954,-62.96558c18.7641,-17.68284 41.64134,-31.00693 66.81664,-38.91497l89.87809,-28.20867l-89.87809,-28.20867c-25.17455,-7.90879 -48.05254,-21.23213 -66.81664,-38.91497c-18.7641,-17.68284 -32.90288,-39.24145 -41.2954,-62.96558l-29.9339,-84.69716z"
    />
  </svg>
);

/**
 * 闪光炫酷按钮
 * @param props
 * @constructor
 */
const SparkleButton: FC<PropsWithChildren<IProps>> = (props) => {
  const { children, className, ...buttonProps } = props;

  return (
    <Button type="primary" icon={<SparkleStar />} className={cx('sparkle-button', className)} {...buttonProps}>
      <span className={cx('spark')}></span>
      <span className={cx('backdrop')}></span>
      <span className={cx('text')}>{children}</span>
    </Button>
  );
};

export default SparkleButton;
